qw-room-list {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  font-family: var(--qw-hotel-font-family);
  width: 100%;
}

.qw-room-list__cards {
  width: 100%;
}

.qw-room-list__card-wrapper {
  margin: var(--qw-hotel-gap-sm) 0;
  width: 100%;
}

.qw-room-list__loading-wrapper {
  position: relative;
}

.qw-room-list--grid .qw-room-list__card-wrapper {
  width: 49%;
}

.qw-room-list--grid .qw-room-list__cards {
  display: flex;
  justify-content: space-between;
  flex-flow: row wrap;
}

.qw-room-list--loaded .qw-room-list__loading-wrapper {
  display: none;
}

.qw-room-list__no-availability {
  margin: var(--qw-hotel-gap-md) 0;
}

qw-room-list qw-image {
  min-height: 200px;
}
